import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class Logger {
  private isLoggingEnabled(): boolean {
    return environment.logs;
  }

  public log(message: string, ...optionalParams: any[]): void {
    if (this.isLoggingEnabled()) {
      console.log(`✅ [LOG]: ${message}`, ...optionalParams);
    }
  }

  public warn(message: string, ...optionalParams: any[]): void {
    if (this.isLoggingEnabled()) {
      console.warn(`⚠️ [WARN]: ${message}`, ...optionalParams);
    }
  }

  public error(message: string, ...optionalParams: any[]): void {
    if (this.isLoggingEnabled()) {
      console.error(`❌ [ERROR]: ${message}`, ...optionalParams);
    }
  }

  public debug(message: string, ...optionalParams: any[]): void {
    if (this.isLoggingEnabled()) {
      console.debug(`🐞 [DEBUG]: ${message}`, ...optionalParams);
    }
  }

  public trace(message: string, ...optionalParams: any[]): void {
    if (this.isLoggingEnabled()) {
      console.trace(`🔍 [TRACE]: ${message}`, ...optionalParams);
    }
  }

  public table(data: any, label: string = ''): void {
    if (this.isLoggingEnabled()) {
      console.log(`📊 TABLE : ${label}`);
      console.table(data);
    }
  }
}
